import { PostApiAuthAuthorizationApiResponse } from "@entities/auth";
import { LOCAL_STORAGE } from "@shared/constants";
import { CheckSentryEnable, SetSentryUser } from "..";

export const logIn = (data: PostApiAuthAuthorizationApiResponse) => {
  const telegramId = data.telegram_id;

  localStorage.setItem(LOCAL_STORAGE.AccessToken, data.access_token || "");
  localStorage.setItem(LOCAL_STORAGE.RefreshToken, data.refresh_token || "");
  localStorage.setItem(LOCAL_STORAGE.SessionId, data.session_id || "");
  localStorage.setItem(LOCAL_STORAGE.UserId, data.user_id || "");
  localStorage.setItem(LOCAL_STORAGE.TelegramId, telegramId.toString() || "");

  if (CheckSentryEnable() && telegramId !== 0) SetSentryUser(telegramId);
};

export const logOut = () => {
  localStorage.removeItem(LOCAL_STORAGE.AccessToken);
  localStorage.removeItem(LOCAL_STORAGE.RefreshToken);
  localStorage.removeItem(LOCAL_STORAGE.SessionId);
  localStorage.removeItem(LOCAL_STORAGE.UserId);
  localStorage.removeItem(LOCAL_STORAGE.TelegramId);
};
